import React from "react";
import { hot } from "react-hot-loader";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { getLogger, LEVELS as LOG_LEVELS, setDefaultLevel } from "common/logger";
import { appRoutes, history } from "root/routes";
import getStore from "store";
import { initializeUploader } from "uploader";
import appConfig from "appConfig";
import App from "../App";
import UploadContainer from "../UploadContainer";

setDefaultLevel(appConfig.logLevel);
const logger = getLogger();

let uploader;
const isHotReloading = module.hot?.status() === "apply";

try {
	uploader = isHotReloading && self.__cldUploader ? self.__cldUploader : initializeUploader();
} catch (err) {
	logger.error("[startApp]: ENCOUNTERED ERROR INITIALIZING UPLOADER !!!", err);
}

if (!uploader && appConfig.logLevel === LOG_LEVELS.LOG) {
	throw new Error("!!!!!!!!! NO UPLOADER !!!!! - CANT CONTINUE");
}

const store = isHotReloading && self.__cldUWStore ? self.__cldUWStore : getStore();

const enableDebug = self.__cldEnableUWDebug = () => {
	setDefaultLevel(LOG_LEVELS.LOG);
	self.__cldUWStore = store;
	self.__cldUwHistory = history;
	self.__cldUploader = uploader;
	self.__cldUploaderStore = uploader.getStore();
};

if (logger.getLevel() === LOG_LEVELS.LOG) {
	enableDebug();// expose interesting objects to the global for debugging purposes during dev
}

const Root = () => {
	return <Provider store={store}>
		<ConnectedRouter history={history}>
			<UploadContainer uploader={uploader}>
				<App key="uw-app-root">
					{appRoutes}
				</App>
			</UploadContainer>
		</ConnectedRouter>
	</Provider>;
};

export default hot(module)(Root);
